<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [autohide]="true"
  [delay]="toast.dismissible ? 6000 : 3000"
  [class]="'bg-' + toast.type.toLowerCase() + ' text-dark'"
  [class.toast-no-close]="!toast.dismissible"
  (hidden)="toastService.remove(toast)"
>
  <!-- ngb-toast renders its own close (X) button whenever a header template is
       present; we rely on that one (its hide() triggers (hidden) above). For
       non-dismissible toasts the .toast-no-close class hides it via CSS. -->
  <ng-template ngbToastHeader>
    <div class="me-auto d-flex align-items-center">
      <i [class]="toast.icon" aria-hidden="true"></i>
      <label class="mx-1 mb-0">
        {{ toast.header || toast.type | translate }}
      </label>
      <span
        *ngIf="toast.code"
        class="badge bg-light text-dark ms-1 font-monospace"
        style="font-size: 0.65rem; font-weight: 600"
      >
        {{ toast.code }}
      </span>
    </div>
  </ng-template>
  {{ toast.body | translate }}
</ngb-toast>
